import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { IMAGES } from '../../data/site';
const proofPoints = ['6 Professional Workflow Volumes', '5 Bonuses', '40+ Clinical Workflow Tools'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream px-4 pb-14 pt-8 sm:px-6 sm:pt-10" data-id="element-206" data-mp="hwimbgplk6uj">
      <div className="mx-auto max-w-5xl" data-id="element-207" data-mp="mtit5tu9tdmp">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-208" data-mp="qvm48hd12g7g">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-navy-700 px-3 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-209" data-mp="qtj6tc9jpksp">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-210" data-mp="10k432t1qyd8g" />
            Created by Dr. Karito
          </span>
          <span className="inline-flex items-center rounded-full border border-navy-200 bg-white px-3 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.14em] text-navy-600" data-id="element-211" data-mp="15mcxltu9pnco">
            DVO Clinical Workflow Builder™
          </span>
        </div>

        <h1 className="mt-6 text-center font-display text-[2.05rem] font-bold leading-[1.1] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-212" data-mp="4o6mbng1j181">
          Build your repeatable DVO case workflow in{' '}
          <em className="text-navy-600" data-id="element-213" data-mp="3rtxoaagx2oal">30 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-214" data-mp="3rvs45adbzq7t">
          Stop starting every complex DVO case from scratch. A practical clinical
          workflow-building system that organizes assessment, records, analysis, decision points,
          validation and reassessment into one structured workflow you can reuse.
        </p>

        <div className="mx-auto mt-7 max-w-3xl" data-id="element-215" data-mp="ekt5m7spxk7y">
          <img src={IMAGES.bundle} alt="The complete DVO Clinical Workflow Builder collection: six workflow volumes, checklists, workflow maps and digital quick references" className="w-full" width={1080} height={1080} data-id="element-216" data-mp="1b51t2emmhv4z" />
        </div>

        <ul className="mx-auto mt-2 flex max-w-xl flex-col items-center gap-2 sm:flex-row sm:justify-center sm:gap-5" data-id="element-217" data-mp="35jyvwsopk674">
          {proofPoints.map(point => <li key={point} className="flex items-center gap-1.5 text-[12.5px] font-semibold uppercase tracking-wide text-ink-soft" data-id="element-218" data-mp="2vv79f02f2e3l">
              <CheckIcon className="h-4 w-4 shrink-0 text-go" aria-hidden="true" data-id="element-219" data-mp="2hxio5r4ft4y0" />
              {point}
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-md" data-id="element-220" data-mp="27xrwryb6b625">
          <CTAButton label="Get the DVO Clinical Workflow Builder™" subline="Instant access · One-time payment · Lifetime access · 7-day guarantee" data-id="element-221" data-mp="27z2zdusvu7ro" />
        </div>
        <div id="hero-cta-anchor" aria-hidden="true" className="h-px w-full" data-id="element-222" data-mp="66oeqnyyep7k" />

        <div className="mt-8" data-id="element-223" data-mp="b3oksyvszryo">
          <Countdown label="This price expires in" data-id="element-224" data-mp="b2lyl49fedp3" />
        </div>

        <p className="mx-auto mt-6 max-w-md text-center text-[12.5px] leading-relaxed text-ink-muted" data-id="element-225" data-mp="1vnsc6b7k8aah">
          Currency is converted automatically — you pay the{' '}
          <strong className="font-bold text-ink-soft" data-id="element-226" data-mp="25dbv1gv9w45c">$27 equivalent</strong> in your local
          currency.
        </p>
      </div>
    </header>;
}